export const unicodeMappings = {
  bold: {
    'a': '𝗮', 'b': '𝗯', 'c': '𝗰', 'd': '𝗱', 'e': '𝗲', 'f': '𝗳', 'g': '𝗴', 'h': '𝗵', 'i': '𝗶', 'j': '𝗷', 'k': '𝗸', 'l': '𝗹', 
    'm': '𝗺', 'n': '𝗻', 'o': '𝗼', 'p': '𝗽', 'q': '𝗾', 'r': '𝗿', 's': '𝘀', 't': '𝘁', 'u': '𝘂', 'v': '𝘃', 'w': '𝘄', 'x': '𝘅', 
    'y': '𝘆', 'z': '𝘇', 'A': '𝗔', 'B': '𝗕', 'C': '𝗖', 'D': '𝗗', 'E': '𝗘', 'F': '𝗙', 'G': '𝗚', 'H': '𝗛', 'I': '𝗜', 'J': '𝗝', 
    'K': '𝗞', 'L': '𝗟', 'M': '𝗠', 'N': '𝗡', 'O': '𝗢', 'P': '𝗣', 'Q': '𝗤', 'R': '𝗥', 'S': '𝗦', 'T': '𝗧', 'U': '𝗨', 'V': '𝗩', 
    'W': '𝗪', 'X': '𝗫', 'Y': '𝗬', 'Z': '𝗭', '0': '𝟬', '1': '𝟭', '2': '𝟮', '3': '𝟯', '4': '𝟰', '5': '𝟱', '6': '𝟲', 
    '7': '𝟳', '8': '𝟴', '9': '𝟵'
  },
  italic: {
    'a': '𝘢', 'b': '𝘣', 'c': '𝘤', 'd': '𝘥', 'e': '𝘦', 'f': '𝘧', 'g': '𝘨', 'h': '𝘩', 'i': '𝘪', 'j': '𝘫', 'k': '𝘬', 'l': '𝘭', 
    'm': '𝘮', 'n': '𝘯', 'o': '𝘰', 'p': '𝘱', 'q': '𝘲', 'r': '𝘳', 's': '𝘴', 't': '𝘵', 'u': '𝘶', 'v': '𝘷', 'w': '𝘸', 'x': '𝘹', 
    'y': '𝘺', 'z': '𝘻', 'A': '𝘈', 'B': '𝘉', 'C': '𝘊', 'D': '𝘋', 'E': '𝘌', 'F': '𝘍', 'G': '𝘎', 'H': '𝘏', 'I': '𝘐', 'J': '𝘑', 
    'K': '𝘒', 'L': '𝘓', 'M': '𝘔', 'N': '𝘕', 'O': '𝘖', 'P': '𝘗', 'Q': '𝘘', 'R': '𝘙', 'S': '𝘚', 'T': '𝘛', 'U': '𝘜', 'V': '𝘝', 
    'W': '𝘞', 'X': '𝘟', 'Y': '𝘠', 'Z': '𝘡'
  },
  boldItalic: {
    'a': '𝙖', 'b': '𝙗', 'c': '𝙘', 'd': '𝙙', 'e': '𝙚', 'f': '𝙛', 'g': '𝙜', 'h': '𝙝', 'i': '𝙞', 'j': '𝙟', 'k': '𝙠', 'l': '𝙡', 
    'm': '𝙢', 'n': '𝙣', 'o': '𝙤', 'p': '𝙥', 'q': '𝙦', 'r': '𝙧', 's': '𝙨', 't': '𝙩', 'u': '𝙪', 'v': '𝙫', 'w': '𝙬', 'x': '𝙭', 
    'y': '𝙮', 'z': '𝙯', 'A': '𝘼', 'B': '𝘽', 'C': '𝘾', 'D': '𝘿', 'E': '𝙀', 'F': '𝙁', 'G': '𝙂', 'H': '𝙃', 'I': '𝙄', 'J': '𝙅', 
    'K': '𝙆', 'L': '𝙇', 'M': '𝙈', 'N': '𝙉', 'O': '𝙊', 'P': '𝙋', 'Q': '𝙌', 'R': '𝙍', 'S': '𝙎', 'T': '𝙏', 'U': '𝙐', 'V': '𝙑', 
    'W': '𝙒', 'X': '𝙓', 'Y': '𝙔', 'Z': '𝙕'
  },
  // Unicode combining characters
  underline: '\u0332',     // Combining low line
  strikethrough: '\u0336'  // Combining long stroke overlay
};

// Utility functions for text transformation

// Helper function to check if a character is a combining character
const isCombiningCharacter = char => {
  const code = char.charCodeAt(0);
  return code >= 0x0300 && code <= 0x036F; // Unicode combining diacritical marks range
};

// Helper to check if a character is a special Unicode character (already formatted)
const isSpecialUnicode = char => {
  // Check if character is in any of the unicode mapped ranges
  const code = char.charCodeAt(0);
  // Mathematical bold (1D400–1D7FF)
  return (code >= 0x1D400 && code <= 0x1D7FF);
};

// Function to replace a character with its Unicode variant while preserving combining marks
const replaceWithUnicode = (char, mapping) => {
  // If the character is already a special Unicode character, return it as is
  if (isSpecialUnicode(char[0])) {
    return char;
  }

  // Get the base character
  const baseChar = char[0];
  
  // Replace the base character
  const newBaseChar = mapping[baseChar] || baseChar;
  
  // Keep any combining characters
  const combiningChars = char.slice(1);
  
  return newBaseChar + combiningChars;
};

// Apply a specific format to a text string
export const applyFormatToText = (text, formatType) => {
  if (!text) return text;
  
  // Split text into grapheme clusters
  // This is a simplified approach, for a full solution we'd need a grapheme splitter library
  const chars = [];
  let currentChar = '';
  
  for (let i = 0; i < text.length; i++) {
    if (i === 0 || !isCombiningCharacter(text[i])) {
      // Start a new character
      if (currentChar) {
        chars.push(currentChar);
      }
      currentChar = text[i];
    } else {
      // Add combining character to current char
      currentChar += text[i];
    }
  }
  
  // Add the last character
  if (currentChar) {
    chars.push(currentChar);
  }
  
  // Apply the requested formatting
  switch(formatType) {
    case 'bold':
      return chars.map(char => replaceWithUnicode(char, unicodeMappings.bold)).join('');
    
    case 'italic':
      return chars.map(char => replaceWithUnicode(char, unicodeMappings.italic)).join('');
    
    case 'boldItalic':
      return chars.map(char => replaceWithUnicode(char, unicodeMappings.boldItalic)).join('');
    
    case 'underline': {
      // Fix for underline: use a more visible underline character
      // and ensure it doesn't break on spaces
      const result = [];
      for (const char of chars) {
        if (char === ' ') {
          result.push(' '); // Keep spaces as is
        } else {
          result.push(char + '\u0332'); // Add underline to non-space characters
        }
      }
      return result.join('');
    }
    
    case 'strikethrough': {
      // Similar fix for strikethrough
      const result = [];
      for (const char of chars) {
        if (char === ' ') {
          result.push(' '); // Keep spaces as is
        } else {
          result.push(char + unicodeMappings.strikethrough); // Add strikethrough to non-space characters
        }
      }
      return result.join('');
    }
    
    case 'bulletList': {
      // Add bullet points to each line
      return text.split('\n')
        .map(line => line.trim() ? '• ' + line : line)
        .join('\n');
    }
    
    case 'numberedList': {
      // Add numbers to each line
      return text.split('\n')
        .map((line, index) => line.trim() ? `${index + 1}. ` + line : line)
        .join('\n');
    }
    
    default:
      return text;
  }
};